import { useEffect, useState } from "react";
import { ArrowUp, MessageCircle } from "lucide-react";

export default function FloatingActions() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const on = () => setVisible(window.scrollY > 400);
    window.addEventListener("scroll", on);
    return () => window.removeEventListener("scroll", on);
  }, []);
  return (
    <>
      <a
        data-testid="whatsapp-float"
        href="https://wa.me/919891782652?text=Hi%20Your%20Trips!%20I%27d%20like%20to%20plan%20a%20trip."
        target="_blank" rel="noreferrer"
        className="wa-pulse fixed bottom-6 right-6 z-50 w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-2xl hover:scale-110"
        aria-label="Chat on WhatsApp"
      >
        <MessageCircle className="w-6 h-6"/>
      </a>
      {visible && (
        <button
          data-testid="back-to-top"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="fixed bottom-24 right-6 z-40 w-11 h-11 rounded-full btn-gold flex items-center justify-center"
          aria-label="Back to top"
        >
          <ArrowUp className="w-5 h-5"/>
        </button>
      )}
    </>
  );
}
